<div class="grid-container margin-top">
  <div class="row clearfix">
    <button class="button float-right hollow" (click)="showAddModulePanel(null)"><svg-icon icon="icon-module-group" class="light-blue"></svg-icon> New Module Group</button>
  </div>
  @if (moduleGroups) {
    <div class="light-gray-bg padding-all">
      @for (moduleGroup of moduleGroups; track moduleGroup; let index = $index) {
        <div class="module-group-container">
          <div class="grid-x minor-margin-bottom">
            @if (moduleGroup.id != editingModuleGroupId) {
              <div class="cell small-12" [ngClass]="{'open-module-group-name': curModule == index}">
                <h2 class="input-height vertical-align-middle no-margin-bottom">
                  <button class="h4 bold padding-right-small no-margin-bottom" (click)="curModule = index">
                    @if (curModule == index) {
                      <svg-icon icon="icon-caret-down" class="small medium-gray"></svg-icon>
                    }
                    @if (curModule != index) {
                      <svg-icon icon="icon-caret-right" class="small medium-gray"></svg-icon>
                    }
                    {{moduleGroup.title}}
                  </button>
                  <button (click)="editModuleGroupName(moduleGroup)" attr.aria-label="Edit Module Group Name" title="Edit Module Group Name: {{moduleGroup.title}}">
                    <svg-icon icon="icon-pencil" class="cursor-pointer medium-gray" aria-hidden="true"></svg-icon>
                  </button>
                  @if (moduleGroup.canDelete) {
                    <button class="display-inline-block no-margin" title="Delete Module Group" attr.aria-label="Delete Module Group: {{moduleGroup.title}}" (click)="deleteModuleGroup(moduleGroup)">
                      <svg-icon icon="icon-trash" class="medium-gray cursor-pointer" aria-hidden="true"></svg-icon>
                    </button>
                  }
                </h2>
                <button class="no-margin float-right input-height vertical-align-middle" attr.aria-label="Add Module" title="Add Module" (click)="showAddModulePanel(moduleGroup)">
                  <svg-icon class="small medium-gray" icon="icon-add" aria-hidden="true"></svg-icon><svg-icon icon="icon-module" class="medium-gray cursor-pointer" aria-hidden="true"></svg-icon>
                </button>
              </div>
            } @else {
              <div class="cell auto text-nowrap">
                <input type="text" [(ngModel)]="moduleGroup.title" class="name-editor">
                <button (click)="updateModuleGroup(moduleGroup)" attr.aria-label="Save Module Group Name" title="Save Module Group Name">
                  <svg-icon icon="icon-save" class="cursor-pointer small medium-gray" aria-hidden="true"></svg-icon>
                </button>
              </div>
            }
          </div>
          <div class="module-group" [ngClass]="{ 'open': index == curModule }">
            @for (module of moduleGroup.modules; track module) {
              <div class="module">
                <div class="grid-x minor-margin-bottom">
                  @if (module.id != editingModuleId) {
                    <div class="cell small-12 large-6 top-border">
                      <svg-icon icon="icon-module" class="tiny medium-gray lightened"></svg-icon>
                      <h3 class="display-inline-block h5 no-margin bold"> {{module.title}}</h3>
                      <button (click)="editModuleName(module)" title="Edit Module Name" attr.aria-label="Edit Module Name">
                        <svg-icon icon="icon-pencil" class="medium-gray cursor-pointer" aria-hidden="true"></svg-icon>
                      </button>
                      @if (moduleGroup.canDelete) {
                        <button class="display-inline-block tiny-margin-right" attr.aria-label="Delete Module {{module.title}}" title="Delete Module {{module.title}}" (click)="deleteModule(moduleGroup, module)">
                          <svg-icon icon="icon-trash" class="medium-gray cursor-pointer" aria-hidden="true"></svg-icon>
                        </button>
                      }
                      @if (module.uriComponent) {
                        <a class="edit-module-dashboard" [routerLink]="['/dashboard/edit', module.uriComponent]">Edit Module Dashboard</a>
                      }
                    </div>
                  } @else {
                    <div class="cell small-12 large-6">
                      <input type="text" [(ngModel)]="module.title" class="name-editor">
                      <button (click)="updateModuleGroup(moduleGroup)" attr.aria-label="Save Module Name" title="Save Module Name">
                        <svg-icon icon="icon-save" class="small medium-gray cursor-pointer" aria-hidden="true"></svg-icon>
                      </button>
                    </div>
                  }
                  <div class="cell large-6 text-align-right flex-align-items-center">
                    <a (click)="showAddLinkPanel(module, moduleGroup)" attr.aria-label="Add Link" title="Add Link" class="minor-margin-right">
                      <svg-icon class="small medium-gray" icon="icon-add" aria-hidden="true"></svg-icon><svg-icon class="small medium-gray" icon="icon-link" aria-hidden="true"></svg-icon>
                    </a>
                    <a [routerLink]="['/dashboard/create', moduleGroup.id, module.id]" attr.aria-label="Add Page" title="Add Page" class="minor-margin-right">
                      <svg-icon class="small medium-gray" icon="icon-add" aria-hidden="true"></svg-icon><svg-icon class="vertical-align-middle small medium-gray" icon="icon-page" aria-hidden="true"></svg-icon>
                    </a>
                    <a [routerLink]="['/builder/flow/new', moduleGroup.id, module.id]" attr.aria-label="Add Workflow" title="Add Workflow" class="minor-margin-right">
                      <svg-icon class="small medium-gray" icon="icon-add" aria-hidden="true"></svg-icon><svg-icon class="vertical-align-middle small medium-gray" icon="icon-sitemap" aria-hidden="true"></svg-icon>
                    </a>
                    <a [routerLink]="['/builder/flow/import', moduleGroup.id, module.id]" attr.aria-label="Import Workflow" title="Import Workflow" [ngClass]="{'minor-margin-right': moduleGroup.canDelete}">
                      <svg-icon class="small medium-gray" icon="icon-upload" aria-hidden="true"></svg-icon>
                    </a>
                  </div>
                </div>
                <ul class="no-bullet">
                  @for (item of module.navigationItems; track item) {
                    <li>
                      <div class="grid-x">
                        @if (item.referenceType === referenceType.Navigation) {
                          <div class="cell small-12 large-auto"><svg-icon icon="icon-link" class="tiny lightened medium-gray minor-margin-right"></svg-icon><a class="medium-bp-bold" [routerLink]="item.uriComponent ? item.route + '/' + item.uriComponent : item.route">{{item.title}}</a></div>
                        }
                        @if (item.referenceType === referenceType.Dashboard) {
                          <div class="cell small-12 large-shrink"><svg-icon icon="icon-page" class="tiny lightened medium-gray minor-margin-right"></svg-icon><span class="minor-margin-right medium-bp-bold">{{item.title}}</span></div>
                          <div class="cell small-12 large-auto"><a [routerLink]="item.uriComponent ? item.route + '/view/' + item.uriComponent : item.route">Edit Page</a></div>
                        }
                        @if (item.referenceType === referenceType.Workflow) {
                          <div class="cell small-12 large-shrink"><svg-icon icon="icon-sitemap" class="tiny lightened medium-gray minor-margin-right"></svg-icon><span class="minor-margin-right medium-bp-bold">{{item.title}}</span></div>
                          <div class="cell small-12 large-auto">@if (item.showEditWorkflow) {
                            <a attr.aria-label="Edit Workflow With Id {{item.id}}" [routerLink]="['/builder/flow', item.uriComponent]">Edit Workflow</a>
                          }</div>
                        }
                        @if (item.referenceType === referenceType.ExternalLink) {
                          <div class="cell small-12 large-shrink"><svg-icon icon="icon-external-link" class="tiny lightened medium-gray minor-margin-right"></svg-icon><span class="minor-margin-right medium-bp-bold">{{item.title}}</span></div>
                        }
                        @if (moduleGroup.canDelete) {
                          <div class="cell small-12 large-shrink vertical-align-middle">
                            <label for="showInNav" class="no-margin inline">
                              <input type="checkbox" id="showInNav" (click)="setIsVisible($event, item, moduleGroup)" [checked]="item.showInNavigation" class="no-margin vertical-align-middle">
                              Show in Navigation
                            </label>
                            <button class="float-right margin-left" attr.aria-label="Delete Item With Id {{item.id}}" (click)="deleteNavigationItem(moduleGroup, module, item)">
                              <span class="show-for-sr">Delete Item With Id {{item.id}}</span>
                              <svg-icon icon="icon-trash" class="medium-gray" aria-hidden="true"></svg-icon>
                            </button>
                          </div>
                        }
                      </div>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
<confirm-dialog [showDialog]="dialogService.showDialog" [dialogType]="dialogService.dialogType" [message]="dialogService.message" (onDialogConfirm)="onDialogConfirm()" (onDialogClose)="onDialogClose()"></confirm-dialog>
